import { render, staticRenderFns } from "./BCardCollapse.vue?vue&type=template&id=61d83dc4"
import script from "./BCardCollapse.vue?vue&type=script&lang=js"
export * from "./BCardCollapse.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports